import { render } from "./Qa.vue?vue&type=template&id=07e70f81&scoped=true"
import script from "./Qa.vue?vue&type=script&lang=js"
export * from "./Qa.vue?vue&type=script&lang=js"

import "./Qa.vue?vue&type=style&index=0&id=07e70f81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e70f81"]])

export default __exports__